'use es6';

import { uniqueId } from 'underscore';
import Widget from 'DesignData/models/widgets/Widget';
/**
 * Tests to see if the passed id is a valid widget id/name as defined by DesignData/models/widgets/Widget
 *
 * @param {String} widgetId
 * @return {Boolean}
 */

function isValidWidgetId(widgetId) {
  return typeof widgetId === 'string' && widgetId.indexOf(Widget.WIDGET_NAME_PREFIX) === 0;
}
/**
 * Helper to ensure widgets returned from server have a widget id.
 *
 * @param {Object} widget
 * @return {String}
 */


export function getOrCreateWidgetIdFromWidget(widget) {
  if (isValidWidgetId(widget.id)) {
    return widget.id;
  }

  if (isValidWidgetId(widget.name)) {
    return widget.name;
  }

  return Widget.generateWidgetName();
}
/**
 * Creates a row id.
 * We're using these as client side only (like a Backbone cid).
 */

export function createRowId() {
  return uniqueId('row_');
}